import React, { useState, useEffect, Suspense } from 'react'
import { useForm } from 'react-hook-form';
import axios from 'axios'
import { Link, useNavigate } from 'react-router-dom';
import { ReactSession } from 'react-client-session';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import $ from "jquery";

import Header from '../../Header/Header';
import Sidebar from '../../Sidebar/Sidebar';
import Loader from '../../Global/Loader';

import styles from '../../../App.module.css';
import classes from './AddWebLink.module.css'
import Tabs from '../Tabs/Tabs';

import noThumb from "../../../images/no-thumb.jpg";

function AddWebLink() {
    const navigate = useNavigate();
    const { register, handleSubmit, reset, formState: { errors } } = useForm();
    const [webGroups, setWebGroups] = useState([]);
    // const [webLink, setWebLink] = useState([]);
    const [webUrl, setWebUrl] = useState('');
    const [image, setImage] = useState('');
    const [thumb, setThumb] = useState(null);
    const [picurl, setPicurl] = useState(null);
    const [privacy, setPrivacy] = useState(true);
    const [ifDisabled, setIfDisabled] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState({
        status: false,
        message: ''
    });
    ReactSession.setStoreType("localStorage");

    const logged_user = ReactSession.get("logged_user");

    const metaContent = () => {
        function getMetaContent(html, name) {
            return html.filter((index, tag) => tag && tag.name && tag.name === name).attr("content");
        }
      
        $.ajax({
            url: "https://proxy.cors.sh/"+webUrl
        }).then(function(data) {
            var html = $(data);
        
            var title = html.filter("title").text();
            var description= getMetaContent(html, "description");
            var img = $(html).filter("meta[property=\'og:image\']").attr("content");

            reset({
                'play_name': title,
                'description': description
            });

            img && setPicurl(img);
            img && setImage(img);

        }).catch(function(err) {
            toast.error('Internal Server Error!');
        })
    }

    useEffect(() => {
        !logged_user && navigate('/login');
    } , [])

    const fetchWebGroups = () => {
        axios.post(`${process.env.REACT_APP_API_URL}/api/user/webgroups.php`, {
            uid: logged_user
        }, {
            headers: {
                "Content-Type": "multipart/form-data",
            }
        })
        .then(res => {
            setWebGroups(res.data);
        }).catch(err => {
            console.log(err);
        })
    }

    useEffect(() => {
        fetchWebGroups();
    }, [])

    const onImageChange = (e) => {
        setThumb(e.target.files[0]);

        let reader = new FileReader();
        reader.onload = (e) => {
            setImage(e.target.result);
        };
        
        if(e.target.files[0]){
            reader.readAsDataURL(e.target.files[0]);
        }else {
            setImage('');
        }
    }

    const handlePrivacy = (e) => {
        if(e.target.value === '1') {
            setPrivacy(false);
        } else {
            setPrivacy(true);
        }
    }

    const onSubmit = (e) => {
        setIfDisabled(true);

        const data = new FormData();
        data.append('uid', logged_user);
        data.append('play-url', e.play_url);
        data.append('play-name', e.play_name);
        data.append('description', e.description);
        data.append('selectGroup', e.selectGroup);
        data.append('private', e.private);
        data.append('play-img', thumb);
        data.append('picurl', picurl);

        axios.post(`${process.env.REACT_APP_API_URL}/api/user/addweblink.php`, data, {
                headers: {
                    "Content-Type": "multipart/form-data",
                }
            }).then(res => {
                setIsSubmitted({
                    status: true,
                    type: res.data.status,
                    message: res.data.message
                });

                setIfDisabled(false);
            }).catch(err => {
                console.log(err);
            })
    }

    return (
        <>
            <Header />
            <div className={styles.main_body}>
            <Suspense fallback="<div>Please wait...</div>">
                <Sidebar />
            </Suspense>
            <Suspense fallback="<div>Please wait...</div>">
                <div className={styles.main_content + ` main-content`}>
                    <div className={classes.video_component + ` p-4`}>
                        <Tabs active="addweblink" />
                        <div className={classes.panel}>
                            <div className={classes.panel_body}>
                                {
                                    !isSubmitted.status ? <div className="row">
                                        <div className="col-8">
                                            <form onSubmit={handleSubmit(onSubmit)}>
                                                <div className="form-group">
                                                    <label>Website URL:</label>
                                                    <div className={classes.d_flex}>
                                                        <input {...register('play_url', {required: true})} className="form-control" type="text" placeholder="Your Website's URL" onChange={(e) => setWebUrl(e.target.value)} />
                                                        <Link to={false} title="Click to autofill" onClick={() => metaContent()}>
                                                            <svg width="25px" height="25px" viewBox="0 0 24 24"><g data-name="Layer 2"><g data-name="checkmark-circle"><path d="M9.71 11.29a1 1 0 0 0-1.42 1.42l3 3A1 1 0 0 0 12 16a1 1 0 0 0 .72-.34l7-8a1 1 0 0 0-1.5-1.32L12 13.54z"/><path d="M21 11a1 1 0 0 0-1 1 8 8 0 0 1-8 8A8 8 0 0 1 6.33 6.36 7.93 7.93 0 0 1 12 4a8.79 8.79 0 0 1 1.9.22 1 1 0 1 0 .47-1.94A10.54 10.54 0 0 0 12 2a10 10 0 0 0-7 17.09A9.93 9.93 0 0 0 12 22a10 10 0 0 0 10-10 1 1 0 0 0-1-1z"/></g></g></svg>
                                                        </Link>
                                                    </div>
                                                    {errors.play_url && <p className={styles.error_msg}>This field cannot be empty</p>}
                                                </div>
                                                <div className="form-group">
                                                    <label>Website Name:</label>
                                                    <input {...register('play_name', {required: true})} className="form-control" type="text" placeholder="Your Website's Title" />
                                                    {errors.play_name && <p className={styles.error_msg}>This field cannot be empty</p>}
                                                </div>
                                                <div className="form-group">
                                                    <label>Website Description:</label>
                                                    <textarea {...register('description')} className="form-control" rows="3" placeholder="Your Website's Description"></textarea>
                                                </div>
                                                <div className="form-group">
                                                    <label>Website Group:</label>
                                                    <select {...register('selectGroup')} className="form-control">
                                                        <option value="0" className="opm">No Group</option>
                                                        <optgroup label="Your Groups" dangerouslySetInnerHTML={{__html: `${webGroups}`}} />
                                                    </select>
                                                </div>
                                                <div className="form-group">
                                                    <label>Website Thumbnails (350px X 250px)</label>
                                                    <input className="form-control" type="file" onChange={onImageChange} />
                                                </div>
                                                <div className="form-group">
                                                    <label>Show group ?</label>
                                                    <div className={`form-group ${classes.radio}`}>
                                                        <label className="radio inline">
                                                            <input type="radio" {...register('private')} className="styled" value="0" checked={privacy} onClick={handlePrivacy} />Public
                                                        </label>
                                                        <label className="radio inline">
                                                            <input type="radio" {...register('private')} className="styled" value="1" checked={!privacy} onClick={handlePrivacy} />Private
                                                        </label>
                                                    </div>
                                                </div>
                                                <div className={`form-group ${styles.btn_flex}`}>
                                                    <button className="btn btn-primary" type="submit" disabled={ifDisabled}>{ifDisabled ? 'Creating WebLink' : 'Create WebLink'}</button>
                                                    {
                                                        ifDisabled && <Loader />
                                                    }
                                                </div>
                                            </form>
                                        </div>
                                        <div className="col-4">
                                            <div className={`${classes.group_thumb} mt-4 mb-3`}>
                                                <label htmlFor="">Thumbnail:</label>
                                                <img width="100%" src={image} onError={e => {e.target.src = noThumb}} alt="thumb" />
                                            </div>
                                        </div>
                                    </div>
                                    : <div className='mt-4'>
                                        <div class={`alert alert-${isSubmitted.type}`} role="alert">{isSubmitted.message}</div>
                                        {
                                            isSubmitted.type === 'success' && <div className="align-center" align="center">
                                                <Link to="/dashboard/webpages" className="btn btn-primary">Manage media.</Link>
                                            </div>
                                        }
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </Suspense>
            </div>
        </>
    )
}

export default AddWebLink